<template>
    <div class="pages newMemberGroup">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/vipset_addgroup_icon.png" alt="">
                <span>{{id ? '编辑会员组' : '新建会员组'}}</span>
            </p>
            <p>
            </p>
        </div>
        <div class="content">
            <ul class="checkTab mb-15">
                <li :class="{'active':types==1 || types==2 || types==3}">
                    <p>1</p>
                    <p>
                        <span>基本信息</span>
                        <span>请填写分组的基础信息，方便管理会员分组</span>
                    </p>
                </li>
                <li :class="{'active':types==2 || types==3}">
                    <p>2</p>
                    <p>
                        <span>分组规则</span>
                        <span>设置分组规则，360度会员透视</span>
                    </p>
                </li>
            </ul>
            <div class="tabw" v-if="types==1">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="分组名称:">
                        <el-input v-model="form.name" placeholder="用于企业内部展示的分组名称"></el-input>
                    </el-form-item>
                    <el-form-item label="分组描述:">
                        <el-input type="textarea" :rows="5" placeholder="请输入分组描述，分组描述仅用于内部展示" resize="none" v-model="form.desc"></el-input>
                    </el-form-item>
                    <el-form-item label="业务系统:">
                        <el-select v-model="form.region" placeholder="请选择业务系统">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="更新方式:">
                        <el-radio-group v-model="form.resource">
                        <el-radio label="1">手动</el-radio>
                        <el-radio label="2">例行</el-radio>
                        </el-radio-group>
                        <p class="liex" v-if="form.resource==2">系统自动每
                            <el-input class="min_ipt" type="text" v-model="form.desc1"></el-input> 天更新一次，更新时间为凌晨00:00:00
                        </p>
                    </el-form-item>
                    <el-form-item label="创建方式:">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">标签创建</el-radio>
                            <el-radio label="2">规则创建</el-radio>
                            <el-radio label="3">混合创建</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tabt" v-if="types==2 && !showOk">
                <labelPopulation @dostep="createds" :type='form.type' v-if="form.type==3 || form.type==1" ref="labelPopulation"></labelPopulation>
                <featuresPopulation :type='form.type' v-if="form.type==2 || form.type==3" @dostep="createds" ref="featuresPopulation"></featuresPopulation>
            </div>
            <span v-if="types==1" class="footer">
                <el-button class="quxiao" @click="handleClose" >取 消</el-button>
                <el-button type="primary"  @click="goType(2)">下一步</el-button>
            </span>
        </div>
        <div class="tab3" v-show="showOk && types==2">
            <p><img src="../../assets/images/newIcon/chenggong_icon.png" alt=""></p>
            <p>创建成功</p>
            <p>新建会员组已完成</p>
            <!-- <p>预计导入xxx人数，成功后可在会员导入中查看</p> -->
            <p>
                <el-button round @click="handleClose">返 回</el-button>
            </p>
        </div>
    </div>
</template>

<script>
import labelPopulation from './components/labelPopulation.vue'
import featuresPopulation from './components/featuresPopulation.vue'
export default {
    data() {
        return {
            showOk:false,
            id:"",
            types:1,
            form: {
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: "3",
            resource: '1',
            desc: '',
            desc1: ''
            }
        }
    },
    components:{
        labelPopulation,
        featuresPopulation
    },
    created(){
        this.id=this.$route.query.id;
    },
    methods: {
        createds(val){
            if(val.type==1){
                this.types=--this.types;
            }else{
                this.showOk=true;
            }
        },
        goType(type){
            this.types=type;
            if(type==2){
                if(this.form.type==3){

                }
            }
        },
        handleClose(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="less" scoped>
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .tab3{
            padding:100px 0;
            background: #fff;
            border-radius: 6px;
            p{
                margin-bottom:15px;
                text-align: center;
                img{
                    width:68px;
                    height:68px;
                }
                &:nth-child(2){
                    font-size: 18px;
                    font-weight: 400;
                    color: #333333;
                }
                &:nth-child(3){
                    font-size: 14px;
                    font-weight: 400;
                    color: #777777;
                }
                &:nth-child(4){
                    font-size: 16px;
                    font-weight: 500;
                    color: #333333;
                }
                &:last-child{
                    font-size: 14px;
                    font-weight: 400;
                    color: #777777;
                }
            }
        }
    .content{
        // padding:30px;
        .checkTab{
            background: #fff;
            padding:60px 0;
            display: flex;
            justify-content: center;
            border-radius: 6px;
            li{
                display: flex;
                align-items: center;
                margin-right:220px;
                position: relative;
                &:last-child{
                    margin:0;
                    &::after{
                        left: -206px;
                    }
                }
                &:first-child{
                    
                    &::after{
                        display:none;
                    }
                    
                }
                &:nth-child(2){
                    &::after{
                        left: -205px;
                    }
                    
                }
                
                &::after{
                    content: '';
                    position: absolute;
                    top: 30px;
                    border-bottom: 1px dashed #A7A7A7;
                    width: 190px;
                    height: 2px;
                }
            }
            .active{
                &::after{
                    border-bottom: 1px dashed #327EFF;
                }
                p{
                    &:last-child{
                        color: #327EFF;
                    }
                    &:first-child{
                        background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                        color:#fff;
                    }
                    span{
                        &:first-child{
                            color:#327EFF;
                        }
                        &:last-child{
                            color:#484848;
                        }
                    }
                }
            }
            p{
                // text-align: center;
                &:first-child{
                    margin:0 auto;
                    margin-right:20px;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    line-height: 64px;
                    text-align: center;
                    background: #EBEBEB;
                    font-size: 34px;
                    font-weight: 500;
                    color: #fff;
                }
                &:last-child{
                    font-size: 14px;
                    font-weight: 400;
                    color: #A1A1A1;
                    span{
                        display: block;
                        color: #999990;
                        &:first-child{
                            margin-bottom:10px;
                            font-size: 20px;
                            font-weight: 500;
                            
                        }
                    }
                }
            }
        }
        .tabw{
            // width:60%;
            padding:30px;
            border-radius: 6px;
            background: #fff;
            .el-form{
                width:50%;
            }
            .el-select{
                width:100%;
            }
            /deep/.el-textarea .el-textarea__inner{
                // width:100%;
                border:0;
                background:#F6F6F6;
            }
            /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
            .min_ipt{
                margin:0 10px;
                width:100px;
            }
            .liex{
                 margin-top:15px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
            .el-form-item{
                margin-bottom:30px;
            }
        }
        
        .footer{
            display: block;
            background: #fff;
            padding:15px 30px;
            border-top:1px solid #ededed;
            .el-button{
                border-radius: 30px;
            }
        }
    }
</style>